module.exports = __webpack_public_path__ + "media/images/404-3f5c061daaa17e3247a4a0f27575afe4.png";